import React from 'react';
import '../style/components/Footer.css';

function Footer() {
  return (
    <footer className='footer'>
      <div className='footerTop'>
        <div className='footerColumn'>
          <h2 className='footerHeading'>Contacto</h2>
          <address className='footerAddress'>
            <p>Calle 16 a # 31-29, Barrio Maridíaz</p>
            <p>Tel: 60 + 2 + 7241963</p>
            <p>
              <a href='mailto:direccion@jardinmelanieklein.com.co'>
                direccion@jardinmelanieklein.com.co
              </a>
            </p>
          </address>
        </div>

        <div className='footerColumn'>
          <h2 className='footerHeading'>Sobre Nosotros</h2>
          <ul className='footerLinks'>
            <li><a href='/nosotros'>Políticas de Calidad</a></li>
            <li><a href='/'>Manual de Convivencia</a></li>
            <li><a href='//www.facebook.com/jardinmklein' target='_blank' rel='noreferrer'>Facebook</a></li>
            <li><a href='//www.instagram.com/jardinmelanieklein.pasto/' target='_blank' rel='noreferrer'>Instagram</a></li>
          </ul>
        </div>

        <div className='footerColumn'>
          <h2 className='footerHeading'>Padres de Familia</h2>
          <ul className='footerLinks'>
            <li><a href='/'>Cronogramas</a></li>
            <li><a href='/'>Formatos</a></li>
            <li><a href='/'>Encuestas</a></li>
            <li><a href='/requisitos'>Requisitos de Matrícula</a></li>
          </ul>
        </div>
      </div>

      <div className='footerBottom'>
        &#xA9; {new Date().getFullYear()} CCR - Pasto, Colombia
      </div>
    </footer>
  );
}

export { Footer };